


















































import Vue from "vue";
import { LoginService, RequestService } from "@/services";
import config from "@/services/config";

const loginService = new LoginService();
const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  components: {
  },
  data: function() {
    return {
      input: {
        token: "",
        username: "",
        passcode: "",
      },
      msgError: "",
      msgTitle: "",
      passwordRecovered: false,
    };
  },

  methods: {
    login: function() {
      const vm = this as any;
      vm.$router.push({ name: 'login' });
    },
    verificaRecuperoPassword: async function() {
      const vm = this as any;
      vm.startLoading();

      const serviceCallReturnValue = await loginService.validateRecuperoPassword(vm.input.token)
        .then(handleResponse)
        .then((result: any) => {
          vm.passwordRecovered = result.jwtState == 'VALID';
          if (vm.passwordRecovered) {
            vm.openModal('Successo', 'Per proseguire, inserire lo username e il codice contenuto nella email.', []);
          } else {
            let msg = "Il link non è valido."
            if (result.jwtState == 'EXPIRED') {
              msg = "Il link è scaduto. Si prega di ripetere la procedura di recupero password.";
            }
            vm.openModal('Errore', msg);
          }
        })
        .catch((error) => {
          console.log(error);
          vm.openModal('Errore', 'Dati non validi');
        });

      vm.stopLoading();
    },
    loginRecuperoPassword: async function() {
      const vm = this as any;
      vm.startLoading();

      let status = null as any;
      const serviceCallReturnValue = await loginService.loginRecuperoPassword(vm.input)
        .then((response: Response) => {
          status = response.status;
          return response.json();
        })
        .then((result: any) => {
          if (status == "200" || status == "222" || status == "223") {
            const homeView = config.codCliente === 'cardif' ? 'home' : 'home-prodotti';
            vm.$router.push({ name: homeView, params: {user: result}});
          } else if (status == "401") {
            vm.openModal("Errore", "Utente non autorizzato");
          }
          return null;
        })
        .catch((error) => {
          console.log(error);
          vm.openModal('Errore', 'Utente non autorizzato');
        });

      vm.stopLoading();
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    openModal(title: string, msg: string) {
      const vm = this as any;
      vm.msgTitle = title;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error-login");
    },
    closeModal() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error-login");
      if (!vm.passwordRecovered) {
        vm.login();
      }
    },
    onClickReturn() {
      const vm = this as any;
      vm.closeModal();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
  },
  mounted() {
    const vm = this as any;
    vm.input.token = vm.$route.query.token;
    vm.verificaRecuperoPassword();
  }
});
